import { FC, MouseEvent, useCallback, useState } from 'react';

import VisibilityIcon from '@mui/icons-material/Visibility';
import Button, { ButtonProps } from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';

import { useRoomRatesEditor, ViewMode } from 'components/RoomRatesEditor';

type Props = ButtonProps & {
  mode: ViewMode;
};

const labels = {
  accommodation: 'Nakvynės kaina',
  total: 'Kelionės kaina',
};

const RoomRatesViewModeButton: FC<Props> = ({ mode, ...rest }) => {
  const { viewMode, setViewMode } = useRoomRatesEditor();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = useCallback((event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();

    setAnchorEl(event.currentTarget);
  }, []);

  const close = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const setMode = useCallback(
    (mode: ViewMode) => (event: MouseEvent<HTMLLIElement>) => {
      event.stopPropagation();
      setViewMode(mode);
      close();
    },
    [close, setViewMode]
  );

  return (
    <>
      <Button
        size="small"
        variant="outlined"
        startIcon={<VisibilityIcon />}
        {...rest}
        onClick={handleClick}>
        {labels[viewMode]}
      </Button>

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={close}>
        <MenuItem onClick={setMode('accommodation')}>
          <ListItemText>{labels.accommodation}</ListItemText>
        </MenuItem>

        <MenuItem onClick={setMode('total')}>
          <ListItemText>{labels.total}</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};

export default RoomRatesViewModeButton;
